import React from "react";
import styled from "styled-components";
import VideoStores from "./components/video-stores";
import { IVideoDistribution } from "types/videoData";
import StoreItem from "./components/store-item";

interface IProps {
  distribution: IVideoDistribution;
  onChange: (distribution: IVideoDistribution) => void;
}
const StepFour = ({ distribution, onChange }: IProps) => {
  const storeData: {
    [key: string]: {
      title: string;
      channelName: string;
      inputLabel: string;
      inputPlaceholder: string;
    };
  } = {
    vevo: {
      title: "VEVO Channel",
      channelName: "VEVO channel",
      inputLabel: "VEVO Channel Name",
      inputPlaceholder: "Enter VEVO channel name"
    },
    apple: {
      title: "Apple Music",
      channelName: "Apple Music channel",
      inputLabel: "Apple Artist URL",
      inputPlaceholder: "Enter Apple Music Artist Link"
    },
    tidal: {
      title: "Tidal",
      channelName: "Tidal channel",
      inputLabel: "Tidal URL",
      inputPlaceholder: "Enter Tidal Artist Link"
    }
  };

  const handleInputChange = (store: string, value: string) => {
    const updatedStores = [...distribution.stores];
    const index = updatedStores.findIndex((s) => s.name === store);

    updatedStores[index] = { ...updatedStores[index], link: value };
    onChange({ ...distribution, stores: updatedStores });
  };
  return (
    <Container>
      <VideoStores
        stores={distribution.stores}
        onChange={(stores) => {
          onChange({ ...distribution, stores });
        }}
      />
      {distribution.stores.map(({ name, link }, i) => {
        return (
          <StoreItem
            key={i}
            value={link}
            title={storeData[name].title}
            channelName={storeData[name].channelName}
            label={storeData[name].inputLabel}
            placeholder={storeData[name].inputPlaceholder}
            onChangeInput={(value) => {
              handleInputChange(name, value);
            }}
          />
        );
      })}
    </Container>
  );
};

export default StepFour;

const Container = styled.div`
  width: 100%;
  position: relative;
`;
